module.exports = __webpack_public_path__ + "static/media/dj.1c186848.svg";